import { render, staticRenderFns } from "./ComplaintTypes.vue?vue&type=template&id=2a4470ea&"
import script from "./ComplaintTypes.vue?vue&type=script&lang=js&"
export * from "./ComplaintTypes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports